import { fetchApi } from './client';
import type { FloorPlanData } from '@/types/floor-plan';

export async function getFloorPlan(floorId: string): Promise<FloorPlanData> {
  return fetchApi<FloorPlanData>(`/api/v1/floors/${floorId}/plan`);
}

export async function updateFloorPlan(floorId: string, data: FloorPlanData): Promise<FloorPlanData> {
  return fetchApi<FloorPlanData>(`/api/v1/floors/${floorId}/plan`, {
    method: 'PUT', body: JSON.stringify(data),
  });
}
